import React from 'react';



import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';



import { AuthProvider, useAuth } from './contexts/AuthContext';



import { ThemeProvider } from './contexts/ThemeContext';



import Sidebar from './components/Sidebar';



import Landing from './pages/Landing';



import PrivacyPolicy from './pages/PrivacyPolicy';



import TermsAndConditions from './pages/TermsAndConditions';



import Login from './pages/Login';



import Register from './pages/Register';



import Home from './pages/Home';



import Profile from './pages/Profile';



import MyCard from './pages/MyCard';



import Contacts from './pages/Contacts';



import Settings from './pages/Settings';



import About from './pages/About';



import PublicCard from './pages/PublicCard';



import Scan from './pages/Scan';



import './styles/global.css';



import './styles/components.css';







const PrivateRoute = ({ children }) => {



  const { user, loading } = useAuth();







  if (loading) {



    return (



      <div style={{ 



        display: 'flex', 



        alignItems: 'center', 



        justifyContent: 'center', 



        minHeight: '100vh',



        color: '#9AA3A8'



      }}>



        Loading...



      </div>



    );



  }







  return user ? children : <Navigate to="/login" />;



};







const PublicRoute = ({ children }) => {



  const { user, loading } = useAuth();







  if (loading) {



    return (



      <div style={{ 



        display: 'flex', 



        alignItems: 'center', 



        justifyContent: 'center', 



        minHeight: '100vh',



        color: '#9AA3A8'



      }}>



        Loading...



      </div>



    );



  }







  return !user ? children : <Navigate to="/" />;



};







function AppRoutes() {



  const { user } = useAuth();



  



  return (



    <div className="app-layout">



      {user && <Sidebar />}



      <div className={user ? "main-content" : "main-content-full"}>



        <Routes>



          <Route path="/" element={



            user ? <Navigate to="/home" /> : <Landing />



          } />



          <Route path="/login" element={



            <PublicRoute>



              <Login />



            </PublicRoute>



          } />



          <Route path="/register" element={



            <PublicRoute>



              <Register />



            </PublicRoute>



          } />



          <Route path="/home" element={



            <PrivateRoute>



              <Home />



            </PrivateRoute>



          } />



          <Route path="/profile" element={



            <PrivateRoute>



              <Profile />



            </PrivateRoute>



          } />



          <Route path="/my-card" element={



            <PrivateRoute>



              <MyCard />



            </PrivateRoute>



          } />



          <Route path="/about" element={



            <PrivateRoute>



              <About />



            </PrivateRoute>



          } />



          <Route path="/settings" element={



            <PrivateRoute>



              <Settings />



            </PrivateRoute>



          } />



          <Route path="/scan" element={



            <PrivateRoute>



              <Scan />



            </PrivateRoute>



          } />
          <Route path="/contacts" element={



            <PrivateRoute>



              <Contacts />



            </PrivateRoute>



          } />



          <Route path="/privacy" element={<PrivacyPolicy />} />



          <Route path="/terms" element={<TermsAndConditions />} />



          <Route path="/card/:cardId" element={<PublicCard />} />



          {/* Catch-all route for custom slugs (e.g., my-omni.link/ramisj) */}

          <Route path="/:slug" element={<PublicCard />} />



          <Route path="*" element={<Navigate to={user ? "/home" : "/"} />} />



        </Routes>



      </div>



    </div>



  );



}







function App() {



  return (



    <Router>



      <ThemeProvider>



        <AuthProvider>



          <AppRoutes />



        </AuthProvider>



      </ThemeProvider>



    </Router>



  );



}







export default App;



